import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import moment from '@g4/moment-utc';
import useCalendarView from './hooks/useCalendarView';
import Calendar from '@g4/next-furniture/Calendar/Calendar';
import { useMedia } from '@g4/boneyard/lib/Media';
import { DEPARTING } from '../../constants';

const propTypes = {
  leg: PropTypes.string,
  isRoundTrip: PropTypes.bool,
  tabDates: PropTypes.shape({
    selected: PropTypes.string,
    middle: PropTypes.string,
  }),
  handleViewToggle: PropTypes.func,
  setSelectedDate: PropTypes.func,
  setSelectedFlight: PropTypes.func,
  lowFareQuery: PropTypes.shape({
    loading: PropTypes.bool,
    lowFares: PropTypes.array,
  }),
  lastAvailableDate: PropTypes.string,
  stadiumGame: PropTypes.object,
  shouldAutoSelect: PropTypes.bool,
  setShouldAutoSelect: PropTypes.func,
  view: PropTypes.string,
  backupTabDate: PropTypes.object,
  setBackupTabDate: PropTypes.func,
};

const LowfareCalendar = ({
  leg,
  isRoundTrip,
  tabDates,
  handleViewToggle,
  setSelectedDate,
  setSelectedFlight,
  lowFareQuery,
  lastAvailableDate,
  stadiumGame,
  shouldAutoSelect,
  setShouldAutoSelect,
  backupTabDate,
  setBackupTabDate,
  view,
}) => {
  const mq = useMedia();

  const { loading, lowFares } = lowFareQuery;

  const {
    calendarContent,
    calendarData,
    calendarAutomationHooks,
    handleSelectDate,
    handleShiftMonth,
  } = useCalendarView({
    leg,
    isRoundTrip,
    tabDates,
    handleViewToggle,
    setSelectedDate,
    setSelectedFlight,
    lowFares,
    loading,
    stadiumGame,
    backupTabDate,
    setBackupTabDate,
    view,
  });

  const isDatePresentInLowfare = lowFares.some(
    lowFare => lowFare.date === calendarData.departureDate
  );

  useEffect(() => {
    if (!isDatePresentInLowfare && leg === DEPARTING) {
      const departingDate = moment(calendarData.departureDate, 'YYYY-MM-DD');
      const availableLowFareList = lowFares.map(lowFare =>
        moment(lowFare.date, 'YYYY-MM-DD')
      );
      const nextAvailableDate = availableLowFareList.find(lowFare =>
        moment(lowFare).isAfter(departingDate, 'day')
      );
      setSelectedDate({
        selected: moment(nextAvailableDate).format('YYYY-MM-DD'),
      });
    }
  }, [
    calendarData.departureDate,
    isDatePresentInLowfare,
    lowFares,
    leg,
    setSelectedDate,
  ]);

  return (
    <Calendar
      className="bg-white"
      selectedDate={moment(tabDates[leg].selected)}
      leg={leg}
      minimumDate={moment()}
      displayDayHeader={mq.lt('md')}
      content={calendarContent}
      onDateChange={handleSelectDate}
      onMonthChange={handleShiftMonth}
      lastAvailableDate={lastAvailableDate}
      automationHooks={calendarAutomationHooks}
      data={calendarData}
      isLoading={loading}
      shouldAutoSelect={shouldAutoSelect}
      setShouldAutoSelect={setShouldAutoSelect}
    />
  );
};

LowfareCalendar.propTypes = propTypes;
LowfareCalendar.displayName = 'LowfareCalendar';

export default LowfareCalendar;
